import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DzIconModule } from '@blk/daisy/core/icon';
import { DzButtonModule } from '@blk/daisy/elements/buttons';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';

import { RedirectCtaComponent } from './redirect-cta.component';

@NgModule({
	declarations: [RedirectCtaComponent],
	imports: [CommonModule, DzButtonModule, DzIconModule.withIcons(faArrowRight)],
	exports: [RedirectCtaComponent]
})
export class RedirectCtaModule { }
